import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import CorrelativesDataTable from "@/components/correlatives/correlatives-table/correlatives-data-table";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";

const correlativesSearchSchema = z.object({
  page: z.number().optional().default(1),
  search: z.string().optional(),
});

export const Route = createFileRoute(
  "/_authenticated/settings/_layout/correlatives",
)({
  validateSearch: correlativesSearchSchema,
  component: CorrelativesPage,
});

function CorrelativesPage() {
  const searchParams = Route.useSearch();

  return (
    <RouteGuardPermissions
      permissions={[{ module: "correlatives", actions: ["read", "update"] }]}
    >
      <div>
        <div>
          <CorrelativesDataTable
            currentPage={searchParams.page}
            pageSize={5}
            basePath="/settings/correlatives"
            searchParams={searchParams}
          />
        </div>
      </div>
    </RouteGuardPermissions>
  );
}
